export default "__VITE_ASSET__B6l_7tgN__"